import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const predictionService = {
  getPredictions: async (page = 1, perPage = 10) => {
    try {
      const response = await axios.get(`${API_URL}/prediccion-diaria/predictions`, {
        params: { page, per_page: perPage }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching daily predictions:', error);
      throw error;
    }
  },

  async getPrediction(id) {
    const response = await axios.get(`${API_URL}/prediccion-diaria/predictions/${id}`);
    return response.data;
  },

  async generateDailyPrediction() {
    const response = await axios.post(`${API_URL}/prediccion-diaria/generate-daily`);
    return response.data;
  }
}; 